<p class="helppoint-title">{{'DOCUMENTGROUP.DIALOG.TITLE' | translate}}</p>
<input-component class="col-x" [(ngModel)]="data.documentGroup"
    placeholder="{{'DOCUMENTGROUP.DIALOG.PLACEHOLDER' | translate}}">
</input-component>
<div align="end">
    <button mat-raised-button class="helppoint-button confirm" (click)="onConfirm()"
        color="primary">{{'MAINTENANCE.ACCEPT' | translate}}</button>
    <button mat-raised-button class="helppoint-button close" (click)="onClose()"
        color="link">{{'CANCEL.BUTTON' | translate}}</button>
</div>
